import { gql } from 'apollo-boost';

export const PATCH_ENROLLMENT_MUTATION = gql`
    mutation patchEnrollment($input: PatchEnrollmentInput!) {
        result: patchEnrollment(input: $input) {
            id
            status
            percentComplete
            rating
            review
        }
    }
`;

// input PatchEnrollmentInput {
//     courseID: UUID!
//     rating: Int!
//     review: String
// }
